/* 
    *  You have to include the store in each modal because  
    *  ionic decided they didn't need to access it. This 
    *  also won't show up in your Vue Debugger.
*/

import './styles.scss';
import store from '../../store/';
import { SITE_URL } from '@/constants/constants';

export default {
    name: 'PrivacyPolicyModal',

    store,

    methods: {
        signAgreement() {
            this.$store.commit('setPrivacyPolicy', Date.now());
            this.$ionic.modalController.dismiss();
        },

        iframeLoaded() {
            console.log('iframeLoaded')
          }
    },

    computed: {
        externalUrl() {
            return `${SITE_URL}/privacy-policy`;
        }
    }
    
};